if(!customElements.get('bundle-builder')) {
  class BundleBuilder extends HTMLElement {
  	constructor() {
      super();

      var config = {
        bundleContainer: this, //bundle box selector
        items: document.querySelectorAll(this.dataset.itemsSelector), //items selector,
        bundleMinItems: parseInt(this.dataset.bundleMinItems), //global minimum required quantity of items in the bundle
        bundleMaxItems: parseInt(this.dataset.bundleMaxItems), //global limit of items in the bundle, 0=no limit
        groupItems: this.dataset.groupItems=='true', // true, or false to view 1 unit item,
        cartBundleMode: this.dataset.cartBundleMode, // "grouped" or "individual",
        showItemsPlaceholder: this.dataset.showItemsPlaceholder=='true',
        stepsContainer: document.querySelector(this.dataset.stepsContainerSelector),
        bannersContainer: document.querySelector(this.dataset.bannersSelectors),
        savings: document.querySelector(this.dataset.savings),
        navigation: document.querySelector(this.dataset.navigation),
        atcMode : this.dataset.addToCartMode
      }
      //nav & panels behavior
      var btnNavClickHandler = ()=>{};
      var slidersById = new Map();
      if (config.stepsContainer.dataset.navMode == 'step_by_step' || config.stepsContainer.dataset.navMode == 'show_tabs' || config.stepsContainer.dataset.navMode == 'show_all') {
        btnNavClickHandler = function() {
          var switchPanel = true;
          var oldActiveButton = config.stepsContainer.querySelector('.step-nav.active');
          var oldActiveStep = this.dataset.step/1;
          var newStep = this.dataset.step/1;
          if (this.classList.contains('active')) {
            //don't switch if it is the active panel;
            switchPanel = false;
          }
          if (switchPanel) {
            var oldActivePanel = config.stepsContainer.querySelector('.step.active');
            var newActivePanel = config.stepsContainer.querySelector('.step[data-step="'+newStep+'"]');
            if(oldActiveButton){
              oldActiveButton.classList.remove('active');
            }
            if(oldActivePanel){
              oldActivePanel.classList.remove('active');
            }
            this.classList.add('active');
            newActivePanel.classList.add('active');
            initOrRefreshPanelSliders(newActivePanel);
          }
        }
      } else {
        btnNavClickHandler = function() {
          var newStep = this.dataset.step/1;
          var newActivePanel = config.stepsContainer.querySelector('.step[data-step="'+newStep+'"]');
          $s.scrollToElement(newActivePanel, 60);
          initOrRefreshPanelSliders(newActivePanel);
        }
      }
      config.stepsContainer.querySelectorAll('.nav .step-nav').forEach(function(btn) {
        btn.addEventListener('click', btnNavClickHandler)
      });

    /**
 * buildSlider(wrapper)
 * Keen Slider v5.5.1 friendly
 *
 * - wrapper: the element that contains slides (the element you pass to new KeenSlider)
 * - expects slide elements to have class "keen-slider-slide" (customizable below)
 */
function buildSlider(wrapper) {
  if (typeof KeenSlider !== 'function') return false;
  if (!wrapper) return false;

  var parent = wrapper.parentElement || document;
  var dotsEl = parent.querySelector('.keen-dots');
  var prevEl = parent.querySelector('.slider-nav .keen-prev');
  var nextEl = parent.querySelector('.slider-nav .keen-next');

  // --- config: change this if your slide class is different ---
  var SLIDE_SELECTOR = '.keen-slider-slide';

  // Utility: get slides array (tries slider.slides first, falls back to wrapper query)
  function getSlidesArray(sliderInstance) {
    if (sliderInstance && sliderInstance.slides && sliderInstance.slides.length) {
      try { return Array.prototype.slice.call(sliderInstance.slides); } catch (e) {}
    }
    // fallback: query wrapper DOM
    var nodes = wrapper.querySelectorAll(SLIDE_SELECTOR);
    return Array.prototype.slice.call(nodes || []);
  }

  // Debounce utility
  function debounce(fn, wait) {
    var t;
    return function() {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function(){ fn.apply(null, args); }, wait);
    };
  }

  // Equalize heights: finds tallest slide and applies height to all
  function equalizeSlideHeights(sliderInstance) {
    var slides = getSlidesArray(sliderInstance);
    if (!slides || !slides.length) return;

    // Reset heights so natural heights can be measured
    for (var i = 0; i < slides.length; i++) {
      slides[i].style.height = 'auto';
    }

    var tallest = 0;
    for (var j = 0; j < slides.length; j++) {
      // Use offsetHeight to include padding/border
      var h = slides[j].offsetHeight;
      if (h > tallest) tallest = h;
    }

    // Apply tallest height
    for (var k = 0; k < slides.length; k++) {
      slides[k].style.height = tallest + 'px';
    }
  }

  // Create the slider (v5 options style)
  var slider = new KeenSlider(wrapper, {
    slidesPerView: 3,
    spacing: 12,
    prevButton: prevEl,
    nextButton: nextEl,
    dots: false,
    breakpoints: {
      '(max-width: 38em)': {
        slidesPerView: 2.2,
        spacing: 6,
        prevButton: false,
        nextButton: false,
        dots: dotsEl
      }
    },

    // Try both created & mounted hooks (some builds differ). We call equalize from mounted,
    // but also guard by a small polling approach below if slides aren't ready yet.
    created: function(s) {
      // small attempt on created (may be too early)
      equalizeSlideHeights(s);
    },
    mounted: function(s) {
      equalizeSlideHeights(s);
    },
    updated: function(s) {
      equalizeSlideHeights(s);
    },
    resized: function(s) {
      equalizeSlideHeights(s);
    }
  });

  // If slider.slides is empty right away, wait until DOM paints / images load:
  // 1) try a few timed attempts (covers lazy initialization)
  // 2) also set up a MutationObserver on wrapper to detect slide insertion
  (function ensureSlidesThenEqualize() {
    var attempts = 0;
    var maxAttempts = 10;

    var interval = setInterval(function() {
      attempts++;
      var slides = getSlidesArray(slider);
      if (slides && slides.length) {
        clearInterval(interval);
        equalizeSlideHeights(slider);
      } else if (attempts >= maxAttempts) {
        clearInterval(interval);
        // still try one last time (best-effort)
        equalizeSlideHeights(slider);
      }
    }, 150);
  })();

  // MutationObserver: if slides are added later, run equalizer
  try {
    var mo = new MutationObserver(function(mutations) {
      // run only when childList changes
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].type === 'childList') {
          equalizeSlideHeights(slider);
          break;
        }
      }
    });
    mo.observe(wrapper, { childList: true, subtree: false });
  } catch (e) {
    // MutationObserver not supported -> ignore
  }

  // Run after window.load (images finished)
  window.addEventListener('load', function() {
    equalizeSlideHeights(slider);
    // also refresh slider in case layout changed
    try { slider.refresh(); } catch(e) {}
  });

  // Debounced resize handler
  var onResize = debounce(function() {
    equalizeSlideHeights(slider);
    try { slider.refresh(); } catch(e) {}
  }, 120);
  window.addEventListener('resize', onResize);

  // Small delayed calls to handle slow image loads / hidden container reveals (Shopify)
  setTimeout(function(){ equalizeSlideHeights(slider); try{ slider.refresh(); } catch(e){} }, 300);
  setTimeout(function(){ equalizeSlideHeights(slider); try{ slider.refresh(); } catch(e){} }, 700);

  return slider;
}

      function initOrRefreshPanelSliders(panel){
        if(!panel) return;
        var wrappers = panel.querySelectorAll('.products-slider');
        wrappers.forEach(function(wrapper){
          var id = wrapper.getAttribute('id') || Math.random().toString(36).slice(2);
          if(!wrapper.getAttribute('id')) wrapper.setAttribute('id', id);
          var instance = slidersById.get(id);
          if(instance){
            try { instance.refresh(); } catch(e) {}
          } else {
            var created = buildSlider(wrapper);
            if(created){ slidersById.set(id, created); }
          }
        });
      }

      function initAllSliders(){
        if(!config.stepsContainer) return;
        var panels = config.stepsContainer.querySelectorAll('.step');
        var forced = [];
        panels.forEach(function(panel){
          if (getComputedStyle(panel).display === 'none') {
            panel.classList.add('force-visible');
            forced.push(panel);
          }
          initOrRefreshPanelSliders(panel);
        });
        // cleanup forced visibility
        forced.forEach(function(panel){ panel.classList.remove('force-visible'); });
      }

      function refreshAllSliders(){
        slidersById.forEach(function(instance){
          try { instance.refresh(); } catch(e) {}
        });
      }

      // Initialize product carousels for all steps
      (function initProductsSliders(){
        if (typeof KeenSlider !== 'function' || !config.stepsContainer) return;
        initAllSliders();
        setTimeout(function(){ refreshAllSliders(); }, 120);
      })();

      /* start of builder */
      var Bundler = (function(config) {
        var self = {};
        var container = config.bundleContainer;
        self.dataJson = JSON.parse(container.querySelector('[type="application/json"]').textContent);
        self.stats = {count: 0, total: 0, discount_code: '', incomplete_products_steps: self.dataJson.products_steps.map((x,key)=>key).filter(x=>x>0)};


        var itemsAdded = [];
        var uniqIndex = 1;
        var uniq = function() {
          return 'k-' + uniqIndex++;
        }
        var variantUnits = function(id, currentStep) {
          return itemsAdded.reduce((x,y)=>x + (id == y.variant_id && currentStep == y.step  ? y.quantity : 0), 0);
        }
        var productUnits = function(id, currentStep) {
          return itemsAdded.reduce((x,y)=>x + (id == y.product_id && currentStep == y.step ? y.quantity : 0), 0);
        }
        self.add = function(variantId, quantity, htmlItem) {
          var index = itemsAdded.map((x)=>x.variant_id).lastIndexOf(variantId);
          var item;
          if (config.groupItems && index != -1) {
            item = itemsAdded[index];
            item.quantity += quantity
          } else {
            var json = JSON.parse(htmlItem.querySelector('[type="application/json"][data-product-json]').textContent);
            item = {
              variant_id: variantId,
              quantity: quantity,
              key: uniq(),
              product_id: htmlItem.dataset.productId,
              title: htmlItem.querySelector('.title').innerText,
              image: htmlItem.querySelector('.img.main').outerHTML,
              variant: json.variants.find((x)=>x.id==variantId),
              productData: json,
              step: htmlItem.step
            };
            itemsAdded.push(item);
          }
          self.drawItem(item);
          
        }
        self.remove = function(variantId, removeQuantity, currentStep) {
          var index = itemsAdded.map((x)=>{return currentStep==x.step ? x.variant_id : 0}).lastIndexOf(variantId);
          self.removeByIndex(index, removeQuantity);
        }
        self.removeByKey = function(key) {
          var index = itemsAdded.findIndex((x)=>x.key==key);
          var item = itemsAdded[index];
          self.removeByIndex(index, item.quantity);
        }
        self.removeByIndex = function(index, removeQuantity) {
          var item = itemsAdded[index];
          item.quantity -= removeQuantity;
          if (item.quantity == 0) {
            itemsAdded.splice(index, 1);
          }
          self.drawItem(item, true);
        }
        self.drawItem = function(item, isRemove) {
          var itemsContainer = container.querySelector('.bundle-items');
          var hiddenEmptySlots = Array.from(
            container.querySelectorAll('.bundle-item-empty')
          ).filter(el => getComputedStyle(el).display === 'none');
          var emptySlots = hiddenEmptySlots.length + 1;
          var currentStep = item.step;
          var top = container.querySelector('.top');
          var html = `
            <div class="bundle-item" data-key="${item.key}" data-step="${currentStep}">
              <div class="grid">
              HOLA
                <div class="grid-item">
                  <div class="image">${item.image}</div>
                </div>
                <div class="grid-item">
                  <div class="title">${item.title}</div>
                  <div class="hide variant-title">${item.variant.title}</div>
                  <div class="flex justify-content-between align-items-center">
                    <div class="flex hide price-quantity-wrapper">
                      <div class="price"><span class="money">` + $s.formatMoney(item.variant.price) + `</span>&nbsp;|&nbsp;</div>
                      <div class="quantity">Qty: <span class="count">${item.quantity}</span></div>
                    </div>
                    <button class="remove" aria-label="${lngg.bundle_builder_remove_item}">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><rect x="1" y="1" width="18" height="18" rx="9" stroke="black" stroke-width="2"/><path d="M6 14L14 6M6 6L14 14" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </button>
                  </div>
                </div>
                <div class="hide free-badge">Free Gift</div>
              </div>
            </div>
            `;
          var existingItem = itemsContainer.querySelector('[data-key="' + item.key + '"]');
          if (item.quantity == 0) {
            html = '';
          }
          if (existingItem) {
            existingItem.outerHTML = html;
            if(emptySlots == 5){
              var iconHTML = container.querySelector('#bundle-icon-template').innerHTML;
              top.querySelector('.title').classList.add('red');
              top.querySelector('.title').innerHTML = "You’ve unlocked a <b>Free Gift</b>.";
              top.querySelector('.subtitle').innerHTML = "Add it now to make your bundle even better!";
                if(itemsContainer.querySelector('.bundle-item-empty.gift')){
                  itemsContainer.querySelector('.bundle-item-empty.gift').innerHTML = iconHTML;
                  itemsContainer.querySelector('.bundle-item-empty.gift').classList.add('rewards');
                }
            }
            if(emptySlots <= 4){
              top.querySelector('.title').innerHTML = "";
              top.querySelector('.subtitle').innerHTML = "";
            }
            
    
          } else {
            
              container.querySelector('.bundle-item-empty[data-step="'+item.step+'"').style.display = "none";
              itemsContainer.insertAdjacentHTML("beforeend", html); // fallback if no empty slot
          }
          if (html != '') {
            itemsContainer.querySelector('.bundle-item[data-key="' + item.key + '"] .remove').addEventListener('click', function() {
              self.removeByKey(item.key);
            });
          }
          self.updateUI(item.step, isRemove);
        }

        self.drawFormInputs = function() {
          //TODO Subscription updates here (replace variant_id, set subscription properties or selling plan value)
          var html = ''
          var bundleId = new Date().getTime() + '-' + Math.floor(Math.random()*9999 + 1000);

          //walk array in reverse order (then cart items order will match what user see in the bundler builder)
          for (var index = itemsAdded.length -1; index>=0; index--) {
            var item = itemsAdded[index];

            
            // Find the selling plan group with the matching name
            if(item.productData && item.productData.sellingPlanGroups){       
              var group = item.productData.sellingPlanGroups.find(
                g => g.name.includes("4 week")
              );
  
              // Extract the ID of the first selling plan in that group (if found)
              var sellingPlanId = group?.selling_plans?.[0]?.id || null;

              html += `
              <input type="hidden" name="items[${index}][selling_plan]" value="${sellingPlanId}" tabindex="0">
              <input type="hidden" name="items[${index}][selling_plan_frequency]" value="4 week subscription with 5% discount" tabindex="0">
              `
            }

            var mode = config.cartBundleMode == 'grouped' ? (index==0?'main' : 'related_multiple') : 'individual';
            html += `
              <input type="hidden" name="items[${index}][id]" value="${item.variant_id}">
              <input type="hidden" name="items[${index}][properties[_bundle_id]]" value="${bundleId}">
              <input type="hidden" name="items[${index}][properties[_bundle_item]]" value="${mode}">
              <input type="hidden" name="items[${index}][properties[_bundle_item]]" value="${mode}">
              <input type="hidden" name="items[${index}][properties[_bundle_type]]" value="bundle_builder">
              <input type="hidden" name="items[${index}][quantity]" value="${item.quantity}">
              `;
              if (config.cartBundleMode == 'grouped') {
                html += `
                <input type="hidden" name="items[${index}][properties[_locked]]" value="quantity">
                  `;
              }
              if (!config.groupItems) {
              html += `
                <input type="hidden" name="items[${index}][properties[_bundle_position]]" value="${index + 1}">
                `;
            }
          }
          container.querySelector('.form-inputs').innerHTML = html;
        }
        self.updateUI = function(currentStep, isRemove) {

          //TODO Subscription updates here (show discounted price, don't change the variant id)
          var itemsContainer = container.querySelector('.bundle-items');
          var totalCount = itemsAdded.reduce((x,y)=>x + y.quantity, 0);
          var totalPrice = itemsAdded.reduce((x,y)=>x + y.variant.price * y.quantity, 0);
          self.stats.count = totalCount;
          self.stats.total = totalPrice;
          self.stats.discounted_price = '';

          const step4 = document.querySelector('.step[data-step="4"]');
          if (step4) {
            step4.style.pointerEvents = 'none';
            step4.style.opacity = '0.5';
            step4.style.userSelect = 'none';
          }
          if(itemsAdded.length >= 3){
            step4.style.pointerEvents = 'auto';
            step4.style.opacity = '1';
            step4.style.userSelect = 'auto';
          }

          self.dataJson.products_steps.forEach(function(pd_step, stepIx) {
            var currentStep = stepIx + 1;
            var stepConfig = self.dataJson.products_steps[stepIx];
            var stepContainter = config.stepsContainer.querySelector('.step[data-step="'+currentStep+'"]')
            var itemsAddedFromStep = itemsAdded.filter(x=>x.step==currentStep);
            var totalCountInStep = itemsAddedFromStep.reduce((x,y)=>x + y.quantity, 0);
            if (stepContainter) {
              stepContainter.querySelectorAll('.selected-quantity').forEach(x=>x.innerHTML = totalCountInStep);
            }

            var incompleteStepsItemIndex = self.stats.incomplete_products_steps.indexOf(currentStep);
            if (stepConfig.min_items > 0 && totalCountInStep < stepConfig.min_items) {
              if (incompleteStepsItemIndex==-1) {
                self.stats.incomplete_products_steps.push(currentStep);
              }
            } else if (incompleteStepsItemIndex > -1) {
              if(self.stats.incomplete_products_steps.length == 2){
                self.stats.incomplete_products_steps.pop();
              }
              self.stats.incomplete_products_steps.splice(incompleteStepsItemIndex, 1);
            }

            config.items.forEach(function(item) {
              if (item.step!=currentStep) {
                return;
              }
              //update number in quantity box (useful when removing items with the X)
              var currentVariantId = item.querySelector('[data-variant-id]').value;
              var currentVariantUnits = variantUnits(currentVariantId, currentStep);
              item.querySelector('input[type="number"]').value = currentVariantUnits;

              //disable/enable MINUS button
              item.querySelectorAll('.quantity-button.minus').forEach(function(element) {
                if (item.querySelector('[type="number"]').value == 0) {
                  element.setAttribute('disabled', true);
                } else {
                  element.removeAttribute('disabled');
                }
              });
              
              //disable/enable PLUS and ADD buttons
              item.querySelectorAll('.quantity-button.plus, .btn.add').forEach(function(element) {
                var variantInput = item.querySelector('[data-variant-id]')
                var productId = item.dataset.productId;
                if (element.classList.contains('chosenOne')) {
                  element.removeAttribute('disabled');
                  return; // stop processing this element
                }

                if ( (config.bundleMaxItems > 0 && totalCount>=config.bundleMaxItems)
                  || (stepConfig.max_items > 0 && totalCountInStep>=stepConfig.max_items)
                  || (stepConfig.item_limit > 0 && variantUnits(variantInput.value, currentStep) >= stepConfig.item_limit)
                  || (stepConfig.product_limit > 0 && productUnits(productId, currentStep) >= stepConfig.product_limit) ) {
                  element.setAttribute('disabled', true);
                } else {
                  element.removeAttribute('disabled');
                }
              });
            });

          });

          
          
          if (config.showItemsPlaceholder) {
            const currentPlaceholders = itemsContainer.querySelectorAll('.item-placeholder').length;
            const missing = config.bundleMaxItems - (itemsAdded.length + currentPlaceholders);
            if(isRemove){
              container.querySelector('.bundle-item-empty[data-step="'+currentStep+'"').style.display = "flex";
            }
            if (missing > 0) {
              const emptyContent = container.querySelector('#bundle-empty-template').innerHTML;
              const emptyGift = container.querySelector('#bundle-empty-gift').innerHTML;
          
              let placeholder = Array.from({ length: missing }, (_, i) => {
                const index = itemsAdded.length + currentPlaceholders + i + 1; // overall position
                if (index === config.bundleMaxItems && !isRemove) {
                  return `<div data-step="4" class="bundle-item-empty item-placeholder gift">${emptyGift}</div>`;
                } else {
                  return `<div data-step="${index}" class="bundle-item-empty item-placeholder">${emptyContent}</div>`;
                }
              }).join('');
          
              itemsContainer.insertAdjacentHTML('beforeend', placeholder);
            }
          }
          


          //disable/enable ADD BUNDLE TO CART button if conditions not meet
          var enableAddBundle = true;
          if ((self.stats.incomplete_products_steps.length - 1) > 0 || (config.bundleMinItems > 0 && totalCount < config.bundleMinItems)) {
            enableAddBundle = false;
          }
          if (enableAddBundle) {
            config.stepsContainer.querySelectorAll('.step-nav').forEach((e)=>{
              if(!e.classList.contains('done')){
                e.classList.add('done');
              }
            })
            if(config.atcMode == 'sidecart'){
              container.querySelector('.btn.add').innerHTML = `Add to Cart`;
            }else{
              container.querySelector('.btn.add').innerHTML = `Proceed to Checkout`;
            }
            container.querySelector('.btn.add').removeAttribute('disabled');
          } else {
            var hiddenItems = [...document.querySelectorAll('.bundle-item-empty')].filter(
              el => getComputedStyle(el).display === 'none'
            );
            var total = 3 - hiddenItems.length
            container.querySelector('.btn.add').innerHTML = `Add ${total} More`;

            container.querySelector('.btn.add').setAttribute('disabled', true);
          }

          let counter = 0;
          //disable/enable step nav buttons after a step not completed
          if (config.stepsContainer.dataset.navMode == 'step_by_step' || config.stepsContainer.dataset.navMode == 'show_all') {
            var firstStepIncomplete = null;
            if (self.stats.incomplete_products_steps.length>0) {
              firstStepIncomplete = Math.min(...self.stats.incomplete_products_steps);
            }
            config.stepsContainer.querySelectorAll('.nav .step-nav').forEach(function(btn, ix) {
              if (firstStepIncomplete && ix+1 > firstStepIncomplete) {
                btn.setAttribute('disabled', true);
                if(btn.classList.contains('done')){
                  btn.classList.remove('done');
                }
              } else {
                btn.removeAttribute('disabled');
                setTimeout(() => {
                  var currentStep = config.stepsContainer.querySelector('.step-nav.active').dataset.step;
                  var stepDone = config.stepsContainer.querySelector('.step-nav.active').dataset.step -1;
                  var oldButton = config.stepsContainer.querySelector('.step-nav[data-step="'+stepDone+'"]');
                  var newBanner = config.bannersContainer.querySelector('.wrapper-top[data-step="'+currentStep+'"]');
                  var oldBanner = config.bannersContainer.querySelector('.wrapper-top[data-step="'+stepDone+'"]');
                  if(oldButton){
                    oldButton.classList.add('done');
                  }
                  if(currentStep >= 3){
                    config.stepsContainer.querySelector('.step-nav[data-step="'+2+'"]').classList.add('done');
                    config.stepsContainer.querySelector('.step-nav[data-step="'+1+'"]').classList.add('done');
                  }
                  if(newBanner){
                    //config.bannersContainer.querySelectorAll('.wrapper-top').forEach(x=>x.classList.add('hide'));
                    //newBanner.classList.remove('hide');
                  }
                }, "200");
                btn.click();
              }
            });
          }


          self.updateProgress();
          
          if(container.querySelector('.count')){
            container.querySelector('.count').innerHTML = totalCount;
          }
          var finalPrice = self.stats.discounted_price ? self.stats.discounted_price : totalPrice;
          var savings = (self.stats.total - self.stats.discounted_price);

          container.querySelector('.savings .savings-price').innerHTML = ``+ $s.formatMoney(savings) + ``;

          container.querySelector('.subtotal .price').innerHTML = `
            ` + (self.stats.discounted_price ? `<span class="retail money"><span class="visually-hidden">${lngg.product__original_price_label}: </span>` + $s.formatMoney(self.stats.total) + `</span>` : ``) + `
            <span class="deal money">` + (self.stats.discounted_price ? `<span class="visually-hidden">${lngg.product__final_price_label}: </span>` : ``) + $s.formatMoney(finalPrice) + `</span>
            `;
        }

        self.updateProgress = function() {
          //progress bar UI
          if (self.dataJson.progress_steps.length > 0) {
            var steps = self.dataJson.progress_steps;
            var progressType = self.dataJson.progress_type;
            var currentValue = progressType == 'quantity' ? self.stats.count : self.stats.total/100;
            var values = steps.map((step)=>step.value);
            var maxValue = Math.max(...values);
            var completedCaption = container.querySelector('.progress-completed');
            var caption = container.querySelector('.progress-caption');

            var progressLongValue = container.querySelector('.progress-value');
            var progressBars = container.querySelectorAll('.progress-bar');

            if (self.dataJson.progress_steps_independent) {
              progressBars.forEach(function(progressBar, ix) {
                var progressValue = progressBar.querySelector('.progress-value');
                var barValue = Math.min(currentValue / values[ix] * 100, 100);
                progressValue.style.width = barValue + '%';
                var dot = progressBar.querySelector('.progress-dot');
                if (barValue==100) {
                  dot.classList.add('completed');
                } else {
                  dot.classList.remove('completed');
                }
              });
            } else {
              var barValue = Math.min(currentValue / maxValue * 100, 100);
              progressLongValue.style.width = barValue + '%';
              progressBars.forEach(function(progressBar, ix) {
                progressBar.style.width = (values[ix] - (ix==0 ? 0 : values[ix-1]) ) / maxValue * 100 + '%';
                var dot = progressBar.querySelector('.progress-dot');
                if (values[ix]<=currentValue) {
                  dot.classList.add('completed');
                } else {
                  dot.classList.remove('completed');
                }
              });
            }

            caption.innerHTML = '';
            completedCaption.innerHTML = '';
            var stepCompletedIndex = -1;
            for (var i=0; i<steps.length; i++) {
              var step = steps[i];
              if (currentValue < step.value) {
                //next step
                var diff = step.value - currentValue;
                caption.innerHTML = step.caption_step_in_progress
                  .replace('[CURRENT_VALUE]', (progressType=='quantity' ? currentValue : $s.formatMoney(currentValue * 100)) )
                  .replace('[VALUE_REQUIRED]', (progressType=='quantity' ? diff : $s.formatMoney(diff * 100)) );
                break;
              } else {
                stepCompletedIndex = i;
                completedCaption.innerHTML = step.caption_step_completed;
                config.savings.querySelector('.savings-percentage').classList.remove('hide');
                config.savings.querySelector('.savings-percentage').innerHTML = step.caption_step_completed;
                self.stats.discount_code = step.discount_code || '';
                if (step.discount_percentage) {
                  self.stats.discounted_price = self.stats.total * (100 - step.discount_percentage) / 100;
                }
              }
            }            

          }
        }


  
        function init() {
          var addButton = container.querySelector('.btn.add');
          if (addButton) {
            addButton.addEventListener('click', function() {
              var add = ()=> {
                self.drawFormInputs();
                var data = new FormData();
                var formInputs = container.querySelector('.form-inputs');
                if (formInputs) {
                  formInputs.querySelectorAll('[name]:checked,[name]:not([type="checkbox"]):not([type="radio"])').forEach(x=>data.append(x.name, x.value));
                }
                $s.post({
                  url: '/cart/add.js',
                  data: data,
                  success: function(){
                    if(config.atcMode == 'sidecart'){
                      $s.addToCartSuccess();
                    }else{
                      window.location = '/checkout'
                    }
                  },
                  error: function(response){
                    $s.addToCartFail(response.description);
                  }
                })
              }
              
              $s.showLoadingOverlay();

              if (self.stats.discount_code) {
                $s.get({url: '/discount/'+self.stats.discount_code, success: add})
              } else {
                add();
              }
            });
          }

          var expandButton = container.querySelector('.expand-button');

          if (expandButton) {
            expandButton.addEventListener('click', function (e) {
              e.preventDefault();
          
              var panel = container.querySelector('.medium-down--expandable');
              if (!panel) return;
          
              // normalize state (if missing, default to false)
              var expanded = this.getAttribute('aria-expanded') === 'true';
          
              if (!expanded) {
                this.setAttribute('aria-expanded', 'true');
                this.setAttribute('aria-label', this.dataset.ariaExpandedLabel);
                $s.expand([panel]);
              } else {
                this.setAttribute('aria-expanded', 'false');
                this.setAttribute('aria-label', this.dataset.ariaCollapsedLabel);
                $s.collapse([panel]);
              }
            });
          }

          config.items.forEach(function(item) {
            // Disable product link
            var a = item.querySelector('.product-card-url');
            if (a) a.removeAttribute('href');
          
            var number = item.querySelector('input[type="number"]');
            var variantInput = item.querySelector('input[data-variant-id]');
            var addBtn = item.querySelector('.btn.add');
            if (!number || !variantInput || !addBtn) return;
          
            // Step setup
            item.step = item.closest('[data-step]')?.dataset.step / 1 || 1;
            var currentStep = item.step;
            var stepConfig = self.dataJson.products_steps[currentStep - 1];
          
            // Input setup
            number.setAttribute('min', '0');
            number.value = 0;
            number.setAttribute('disabled', true);
            if (stepConfig && stepConfig.item_limit) {
              number.setAttribute('max', stepConfig.item_limit);
            }
          
            // Handle quantity change
            number.addEventListener('change', function(event) {
              var diff = this.value - variantUnits(variantInput.value, currentStep);
              if (diff > 0) {
                self.add(variantInput.value, diff, item);
              } else if (diff < 0) {
                self.remove(variantInput.value, Math.abs(diff), item.step);
              }
            });
          
            // Handle swatch change
            variantInput.addEventListener('change', function(event) {
              number.value = variantUnits(variantInput.value, currentStep);
            });
          
            // Reset the button to clear any previous events
            var btnDisplay = addBtn.style.display;
            addBtn.outerHTML = `<button type="button" class="btn add" style="display: none">Add to Bundle</button>`;
            addBtn = item.querySelector('.btn.add');
            addBtn.style.display = btnDisplay;
          
            // --- Named handler functions ---
          
            function handleAddClick(event) {
              if (addBtn.classList.contains('chosenOne')) {
                event.preventDefault();
                event.stopPropagation();
                return;
              }
          
              var step = addBtn.closest('.step').dataset.step;
              
              const elementBanners = document.querySelectorAll(`.banners-wrapper.images .wrapper-top[data-step="${step}"]`);

              elementBanners.forEach(element => element.classList.toggle('hide'));

              addBtn.classList.add('chosenOne');
              addBtn.innerHTML =
                "Added <svg xmlns='http://www.w3.org/2000/svg' width='9' height='6' viewBox='0 0 12 9' fill='none'><path d='M1 5L3.66667 7.66667L10.3333 1' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg>";
          
              self.add(variantInput.value, 1, item);
              number.value = variantUnits(variantInput.value, currentStep);
              self.updateUI(currentStep);
          
              // Switch listeners
              addBtn.removeEventListener('click', handleAddClick);
              addBtn.addEventListener('click', handleRemoveClick);
            }
          
            function handleRemoveClick(event) {
              let stepMember = addBtn.closest('.step').dataset.step;
              // Trigger actual remove action
              let removeBtn = document.querySelector(`.bundle-item[data-step="${stepMember}"] button.remove`);
              if (removeBtn) removeBtn.click();
          
              // Reset UI state
              var step = addBtn.closest('.step').dataset.step;
              
              const elementBanners = document.querySelectorAll(`.banners-wrapper.images .wrapper-top[data-step="${step}"]`);

              elementBanners.forEach(element => element.classList.toggle('hide'));
              addBtn.classList.remove('chosenOne');
              addBtn.innerHTML = 'Add to Bundle';
          
              // Switch listeners back
              addBtn.removeEventListener('click', handleRemoveClick);
              addBtn.addEventListener('click', handleAddClick);
            }
          
            // --- Initialize the first listener ---
            addBtn.addEventListener('click', handleAddClick);
          });
          
          self.updateUI(1);
          
        }
        
        init();

        return self;
      })(config);


    }
  }
  customElements.define('bundle-builder', BundleBuilder);
}